<template>
  <!-- <div class="comments" :style="{ height: contentHeight + 48 + 'px' }"> -->
  <div class="comments">
    <div class="scroll-list-wrap" :style="{ height: contentHeight + 'px' }">
      <live-info :live="live" :isVisitor="isVisitor" />
      <div class="divide"></div>
      <!-- <cube-tab-bar
        v-model="selectedLabel"
        :use-transition="disabled"
        ref="tabNav"
        :data="tabLabels"
        :showSlider="true"
      >
      </cube-tab-bar>
      <cube-tab-panels v-model="selectedLabel">
        <cube-tab-panel :style="{ height: 0 + 'px' }" label="互动" :key="0"> -->
          <!-- <p class="title">互动 {{ `(${list.length})` }}</p>
          <cube-scroll
            ref="commentScroll"
            :data="list"
            :options="options"
            @pulling-down="onPullingDown"
            @pulling-up="onPullingUp"
          >
            <div class="list" v-if="list.length > 0">
              <m-comment-item
                v-for="item in list"
                :key="item.id"
                :comment="item"
                @itemClick="itemClickHandler"
              />
            </div>
          </cube-scroll> -->

          <!-- <div
            v-if="live.allowComments === '0'"
            style="font-size: 14px;
              margin: 16px auto;
              width: 50%;
              height: 18px;
              line-height: 18px;
              padding: 2px 12px;
              color: #fff;
              background-color: #1890ff;
              text-align: center;
              border-radius: 15px;"
          >
            禁言中
          </div>
        </cube-tab-panel>
        <cube-tab-panel
          label="相关视频"
          :style="{ height: contentHeight - 70 + 'px', overflow: 'scroll' }"
          key="1"
        >
          <m-video-list
            ref="videoList"
            :src="live.livePlayHlsUrl"
            :name="live.liveTitle"
            :videoList="live.videoList"
            :playing="playNumber"
            @playVideo="handleVideoChange"
          />
        </cube-tab-panel>
      </cube-tab-panels> -->
      <div
        v-if="!isLogin"
        style="font-size: 14px;
          margin: 16px;
          height: 32px;
          line-height: 1px;
          padding: 2px 12px;
          text-align: center;
          border-radius: 15px;"
      >
        <span>游客状态无法发言，请先</span>
        <span
          style="color: #1890ff; marginLeft: 4px"
          @click="handleToLogin"
        >
          登录
        </span>
      </div>
      <div
        v-if="live.allowComments === '0'"
        style="font-size: 14px;
          margin: 16px auto;
          width: 50%;
          height: 18px;
          line-height: 18px;
          padding: 2px 12px;
          color: #fff;
          background-color: #1890ff;
          text-align: center;
          border-radius: 15px;"
      >
        禁言中
      </div>
      <comments
        :isLogin="isLogin"
        v-show="selectedLabel === '互动' && live.allowComments === '1'"
        :contentHeight="contentHeight"
        :live="live"
        @checkLogin="checkLogin"
      />
    </div>
    <!-- <div v-if="isShowInput" class="mask" @click="blurHandle" />
    <div :class="{ input: true, show: isShowInput }">
      <cube-form :model="model">
        <div class="btns">
          <a class="back" @click="blurHandle">返回</a>
          <h6>写互动</h6>
          <a class="submit" @click="submitHandle">发布</a>
        </div>
        <cube-form-item :field="fieldComment">
          <cube-textarea
            ref="textarea"
            v-model="model.textareaValue"
            :placeholder="textareaPlaceholder"
            :maxlength="maxlength"
            @focus="focusHandler"
            @input="inputChange"
          ></cube-textarea>
        </cube-form-item>
      </cube-form>
    </div>
    <div v-if="selectedLabel === '互动'" ref="apply" class="apply" @click.prevent="inputHandle">
      <input :disabled="true" placeholder="点击发表互动" />
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import liveApi from '@/api/live';
import scrollMixin from '@/mixins/scroll';
import playerMixin from '@/mixins/player';
import liveMixin from '@/mixins/liveCode';
import LiveInfo from './liveInfoCode';
import MVideoList from '@/components/VideoList/Index.vue';
import comments from './comments';

export default {
  name: 'live-comments',
  components: {
    LiveInfo,
    comments,
    MVideoList
  },
  props: {
    live: {
      type: Object,
      required: true,
      default: () => {}
    },
    // 用于判断是否为分享后的视频页面引用
    isVisitor: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  mixins: [scrollMixin, playerMixin, liveMixin],
  data() {
    return {
      selectedLabel: '互动',
      disabled: false,
      btnEnabled: true,
      playNumber: 99999,
      tabLabels: [
        {
          label: '互动'
        },
        {
          label: '相关视频'
        }
      ],
      textareaPlaceholder: '我来互动...',
      wrapHeight: 300,
      list: [],
      isShowInput: false,
      model: {
        textareaValue: ''
      },
      maxlength: 140,
      fieldComment: {
        modelKey: 'textareaValue'
      },
      targetComment: {},
      isFirstShowKewborad: true
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'visitorInfo']),
    isLogin() {
      const user = global.localStorage.getItem('userInfo');
      if (user && JSON.parse(user).uid) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.getComments();
    // if (this.live.allowComments !== '1') {
    //   this.selectedLabel = '相关视频';
    // }
    document.body.addEventListener('focusout', () => {
      // 软键盘关闭事件
      setTimeout(() => {
        window.scroll(0, 0);
      }, 300);
    });
  },
  methods: {
    handleToLogin() {
      this.$emit('handleToLogin')
    },
    checkLogin() {
      console.log(2222222);
      this.$emit('checkLogin');
    },
    inputChange() {
      console.log('===', this.model.textareaValue);
      console.log('===', this.model.textareaValue.length);
    },
    handleVideoChange(params) {
      const { url, index } = params;
      this.$emit('playVideo', { url, index });
      this.playNumber = index;
    },
    onPullingDown() {
      this.page = 1;
      this.getComments();
    },
    onPullingUp() {
      this.page += 1;
      this.getComments();
    },
    getComments() {
      const page = this.page;
      let userInfo = JSON.parse(global.localStorage.getItem('userInfo'));
      let visitorInfo = JSON.parse(global.localStorage.getItem('visitorInfo'));
      let mobile = '';
      if (visitorInfo) {
        mobile = visitorInfo.mobile;
      } else if (userInfo) {
        mobile = userInfo.mobile;
      }
      let params = {
        id: this.liveId,
        schoolName: this.schoolName,
        mobile,
        page: page,
        pageSize: this.pageSize,
        startTime: '',
        type: 1
      };
      liveApi.fetchLiveCommentsCode(params).then(response => {
        const result = response.result.data;
        if (response.result.count > 0) {
          this.comCount = response.result.count;
        }
        if (page > 1) {
          this.list = this.list.concat(result);
        } else {
          this.list = result;
        }

        if (result.length === 0) {
          // 如果没有新数据
          this.$refs.commentScroll.forceUpdate();
        }
      });
    },
    inputHandle() {
      this.selectedLabel = '互动';
      if (this.live.liveStatus === 2) {
        this.$createToast({
          txt: '当前直播已结束',
          type: 'warn'
        }).show();
        return;
      }
      let visitorInfo = JSON.parse(global.localStorage.getItem('visitorInfo'));
      let userInfo = JSON.parse(global.localStorage.getItem('userInfo'));
      if (!visitorInfo && !userInfo) {
        const shareLive = this.$findComponentUpward(this, 'live-share-code');
        shareLive && shareLive.showLogin();
        return;
      }
      this.isShowInput = true;
      this.$refs.textarea.focus();
      this.textareaPlaceholder = '我来互动...';
      this.targetComment = {};
    },
    focusHandler() {
      // iOS：防止第一次获得焦点时，键盘滑到底部，看不见
      // if (this.isFirstShowKewborad) {
      //   this.isFirstShowKewborad = false;
      // } else {
      //   setTimeout(() => {
      //     window.scroll(0, 0);
      //   }, 100);
      // }
    },
    blurHandle() {
      this.isShowInput = false;
      this.$refs.commentScroll.scrollTo(0, 0);
    },
    submitHandle() {
      if (this.btnEnabled) {
        this.btnEnabled = false;
        if (this.model.textareaValue === '') {
          this.$createToast({
            txt: '请填写互动内容',
            type: 'warn'
          }).show();
          return;
        }
        let visitorInfo = JSON.parse(global.localStorage.getItem('visitorInfo'));
        let userInfo = JSON.parse(global.localStorage.getItem('userInfo'));
        let mobile = '';
        let userName = '';
        if (visitorInfo) {
          mobile = visitorInfo.mobile;
          userName = visitorInfo.realname;
        } else if (userInfo) {
          mobile = userInfo.mobile;
          userName = userInfo.realname;
        }
        const params = {
          id: this.liveId,
          mobile,
          userName,
          schoolName: this.schoolName,
          comment: this.model.textareaValue,
          type: 1,
          userPhone: mobile
        };
        liveApi.addCommentCode(params).then(res => {
          if (res.result === true) {
            this.blurHandle();
            this.page = 1;
            this.getComments();
            this.model.textareaValue = '';
            this.$refs.commentScroll.scrollTo(0, 0);
            this.btnEnabled = true;
          } else {
            // 互动失败
            this.$createToast({
              txt: '发送失败',
              type: 'error'
            }).show();
          }
        });
      }
    },
    itemClickHandler(comment) {
      this.targetComment = comment;
      if (this.isVisitor) {
        if (this.visitorInfo.mobile === comment.userPhone) {
          this.showActionSheet();
        } else {
          this.inputHandle();
          this.textareaPlaceholder = `回复 ${comment.userName}`;
        }
      } else {
        if (this.userInfo.mobile === comment.userPhone) {
          this.showActionSheet();
        } else {
          this.inputHandle();
          this.textareaPlaceholder = `回复 ${comment.userName}`;
        }
      }
    },
    showActionSheet() {
      const that = this;
      if (!this.deleteActionSheet) {
        this.deleteActionSheet = this.$createActionSheet({
          data: [
            {
              content: '删除'
            }
          ],
          onSelect: (item, index) => {
            console.log('index: ', index);
            if (item.content === '删除') {
              that.deleteComment();
            }
          }
        });
      }
      this.deleteActionSheet.show();
    },
    deleteComment() {
      liveApi.deleteComment({ commentId: this.targetComment.id }).then(response => {
        if (response.result === true) {
          this.page = 1;
          this.getComments();
          this.model.textareaValue = '';
          this.targetComment = {};
        } else {
          this.$createToast({
            txt: '互动删除失败',
            type: 'error'
          }).show();
        }
      });
    }
  }
};
</script>

<style lang="less">
.comments {
  position: relative;
  width: 100%;
  .cube-tab-bar {
    // padding-left: 10px;
    // padding-right: 10px;
    margin: 0 16px;
    // background-color: rgb(240, 240, 240);

    .cube-tab {
      // width: 100%;
      // flex-basis: unset;
      height: 15px;
      line-height: 15px;
      font-size: 14px;
      // color: rgb(129, 129, 131);
      transition: all 0.3s ease-in;
    }
    // .cube-tab-bar-slider {
    //   width: 80px !important;
    //   margin-left: 50px;
    // }
  }

  .scroll-list-wrap {
    position: relative;
    text-align: left;
    background-color: #f6f7f8;
    p.title {
      font-size: 0.32rem;
      font-weight: 400;
      line-height: 50px;
      padding-left: 10px;
    }

    .divide {
      width: 100%;
      height: 1px;
      background-color: #1890ff;
    }

    .cube-form-item {
      border-top: 1px solid #ddd;
      background: #f5f5f9;
      padding: 0 10px;

      .cube-textarea-wrapper {
        border-radius: 15px;
        background-color: #fff;
        padding: 6px 0;

        textarea {
          padding: 0 15px;
        }

        &.cube-textarea_expanded {
          min-height: 20px;
        }
      }
    }
  }

  .apply {
    display: flex;
    position: fixed;
    bottom: 0;
    width: 100%;
    min-height: 45px;
    border-top: 1px solid #ddd;
    background: #f5f5f9;
    z-index: 99;

    input {
      width: 100%;
      height: 35px;
      line-height: 35px;
      margin: 5px 10px;
      padding: 0 20px;
      border-radius: 30px;
      font-size: 12px;
    }
  }

  .input {
    position: fixed;
    bottom: -150px;
    width: 100%;
    font-size: 14px;
    z-index: 1005;

    &.show {
      bottom: 0;
    }

    .cube-form {
      width: 100%;
      padding-bottom: 10px;

      .cube-form-item {
        margin: 0 15px;
        background: #f9f9f9;
      }
    }

    .btns {
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      line-height: 40px;

      a {
        padding: 0 15px;

        &.back {
          color: #999;
        }

        &.submit {
          // color: #2798fc;
          color: rgb(245, 179, 14);
        }
      }

      h6 {
        font-size: 16px;
      }
    }
  }

  .mask {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #25262d;
    overflow: hidden;
    pointer-events: auto;
    z-index: 1002;
  }
}
</style>
